import { httpCore } from './http.js'
export default {
    status(){
        return ['APPROVED', 'PENDING', 'DENIED', 'BLOCKED']
    },
    add(dto) {
        return httpCore.post(`/company/`, dto);
    },
    finalize(id, dto) {
        return httpCore.post(`/company/${id}/finalize`, dto);
    },
    preLogin(document) {
        return httpCore.post(`/company/preLogin`, { document});
    },
    get(id) {
        return httpCore.get(`/company/${id}`);
    },
    getPublic(id) {
        return httpCore.get(`/company/${id}/public`);
    },
    filter(pageSize, currentPage, searchText, ordem, ordem_por, advanced) {
        var requestParams = {
            pageSize : pageSize,
            actualPage : currentPage,
            query : searchText,
            order : ordem,
            order_by : ordem_por,
            advanced
        };
        return httpCore.post("/company-filter/",requestParams);
    },

    update(id, dto) {
        return httpCore.put(`/company/${id}`, dto);
    },



    walletAddEntry(id, dto) {
        return httpCore.post(`/company/${id}/wallet`, dto);
    },
    walletFilter(pageSize, currentPage, searchText, ordem, ordem_por, advanced, params) {
        var requestParams = {
            pageSize : pageSize,
            actualPage : currentPage,
            query : searchText,
            order : ordem,
            order_by : ordem_por,
            advanced
        };
        return httpCore.post(`/company/${params[0].companyId}/wallet-filter`,requestParams);
    },
}